<div>
  <div class="tabs">
    <div
      class="tab"
      *ngFor="let tab of tabs; let i = index"
      [ngClass]="{ selected: i === selectedIndex }"
      (click)="selectContent(i)"
      matRipple
      matRippleColor="#e0e9f7"
    >
      <div class="tab-label">
        <div class="tab-label-title">
          <span class="tab-label-title-name">{{ tab.name | translate }}</span>
          <ng-container *ngIf="tab.toolTip">
            <mat-icon
              class="tab-label-title-tooltip"
              [glxyTooltip]="tab.toolTip.content | translate"
              [tooltipTitle]="tab.toolTip.title | translate"
              [highContrast]="false"
            >
              info_outline
            </mat-icon>
          </ng-container>
        </div>
        <div class="tab-label-value">
          <span>{{ tab.value }}</span>
          <local-seo-delta *ngIf="tab.showDelta" [value]="tab.deltaValue"></local-seo-delta>
          <div class="tab-label-subtitle" *ngIf="tab.subtitle">{{ tab.subtitle }}</div>
        </div>
      </div>
    </div>
  </div>

  <div [@detailExpand]="openContent ? 'expanded' : 'collapsed'">
    <ng-template *ngIf="!!openContent" [ngTemplateOutlet]="openContent"></ng-template>
  </div>
</div>
